import { tableControlSurfaceSx } from '@/features/shared/components/tableSystem/tablePanelSurfaceSx';
import { tableV2BodyRowHeightPx } from '@/features/shared/components/tableSystem/TableV2Constants';
import { s } from '@/theme/tokens';
import type { SxProps, Theme } from '@/ui/primitives';

type ThemeSxObject = Exclude<SxProps<Theme>, readonly unknown[] | ((theme: Theme) => unknown)>;

export const tableV2RowSurfaceSx = tableControlSurfaceSx satisfies SxProps<Theme>;

type BuildTableV2BodyRowSurfaceSxArgs = {
  hasRenderedDivider: boolean;
};

export const buildTableV2BodyRowSurfaceSx = ({
  hasRenderedDivider,
}: BuildTableV2BodyRowSurfaceSxArgs): ThemeSxObject => ({
  ...tableV2RowSurfaceSx,
  height: `${String(tableV2BodyRowHeightPx)}px`,
  maxHeight: `${String(tableV2BodyRowHeightPx)}px`,
  '& > td': {
    borderBottom: hasRenderedDivider ? (theme: Theme) => `1px solid ${theme.app.colors.border}` : 0,
    boxSizing: 'border-box',
    height: `${String(tableV2BodyRowHeightPx)}px`,
    maxHeight: `${String(tableV2BodyRowHeightPx)}px`,
    overflow: 'hidden',
    py: s('none'),
    verticalAlign: 'middle',
  },
});
